export const goods_zhCN = {
  'item.gift.n01.lbl01': `礼品编号`,
  'item.gift.n01.lbl02': `礼品标题`,
  'item.gift.n01.rdo03': `礼品状态`,
  'item.gift.n01.rdo04': `礼品分组`,
  'item.gift.n01.rdo05': `礼品类别`,
  'item.gift.n01.rdo06': `礼品类目`,
  'item.gift.n02.btn01': `添加礼品`,
  'item.gift.n02.btn02': `导出列表`,
  'item.gift.c01.lbl01': `礼品编号`,
  'item.gift.c01.lbl02': `礼品标题`,
  'item.gift.c01.lbl03': `礼品分组`,
  'item.gift.c01.lbl04': `礼品类别`,
  'item.gift.c01.lbl05': `礼品类目`,
  'item.gift.c01.lbl06': `兑换积分`,
  'item.gift.c01.lbl07': `已领数量`,
  'item.gift.c01.lbl08': `剩余数量`,
  'item.gift.c01.lbl09': `创建时间`,
  'item.gift.c01.lbl10': `礼品状态`,
  'item.gift.c01.lbl11': `操作`,
  'item.gift.d01.txt01': `确定要将该礼品下架吗？`,
  'item.gift.d01.txt02': `确定要将该礼品上架吗？`,
  'item.gift.d02.txt01': `确定要删除该礼品吗？`,

  'item.gift.add.n01.lbl01': `基本设定`,
  'item.gift.add.n02.lbl01': `封面图`,
  'item.gift.add.n02.lbl02': `请上传封面图`,
  'item.gift.add.n02.lbl03': `建议尺寸200px*150px`,
  'item.gift.add.n03.lbl01': `礼品标题`,
  'item.gift.add.n03.lbl02': `礼品副标题`,
  'item.gift.add.n03.lbl03': `礼品详情`,
  'item.gift.add.n04.rdo01': `礼品分组`,
  'item.gift.add.n04.rdo02': `礼品类别`,
  'item.gift.add.n04.rdo03': `礼品类目`,
  'item.gift.add.n04.lbl04': `获取积分值`,
  'item.gift.add.n04.btn05': `选择优惠券`,
  'item.gift.add.n04.lbl06': `礼品价格`,
  'item.gift.add.n04.lbl07': `礼品积分值`,
  'item.gift.add.n04.lbl08': `总库存`,
  'item.gift.add.n05.lbl01': `详情图`,
  'item.gift.add.n05.lbl02': `建议尺寸800px*800px，已上传`,
  'item.gift.add.n06.lbl01': `设置`,
  'item.gift.add.n06.lbl02': `库存预警设置`,
  'item.gift.add.n06.lbl03': `库存小于`,
  'item.gift.add.n06.lbl04': `时，弹框/消息通知品牌商补足库存礼品`,
  'item.gift.add.n07.lbl01': `礼品状态`,
  'item.gift.add.n07.rdo02': `上架`,
  'item.gift.add.n07.rdo03': `下架`,
  'item.gift.add.d01.placeholder01': `请输入优惠券名称`,
  'item.gift.add.d01.lbl02': `选择优惠券`,
  'item.gift.add.d01.lbl03': `优惠券名称`,
  'item.gift.add.d01.lbl04': `适用商品`,
  'item.gift.add.d01.lbl05': `优惠内容`,
  'item.gift.add.d01.lbl06': `领取人限制`,
  'item.gift.add.d01.lbl07': `限领次数`,
  'item.gift.add.d01.lbl08': `剩余库存`,
  'item.gift.add.c02.lbl01': `优惠券`,
  'item.gift.add.c02.lbl02': `优惠券内容`,
  'item.gift.add.c02.lbl03': `操作`,
  'item.gift.add.n08.msg01': `封面图片为必传`,
  'item.gift.add.n08.msg02': `封面图片大小不超过10M`,
  'item.gift.add.n08.msg03': `礼品标题的最大长度不得大于30`,
  'item.gift.add.n08.msg04': `礼品标题为必填项`,
  'item.gift.add.n08.msg05': `礼品标题不能为空`,
  'item.gift.add.n08.msg06': `礼品副标题为必填项`,
  'item.gift.add.n08.msg07': `礼品副标题不能为空`,
  'item.gift.add.n08.msg08': `礼品副标题的最大长度不得大于20`,
  'item.gift.add.n08.msg09': `礼品详情为必填项`,
  'item.gift.add.n08.msg10': `礼品详情不能为空`,
  'item.gift.add.n08.msg11': `礼品详情的最大长度不得超过100`,
  'item.gift.add.n08.msg12': `礼品分组为必选`,
  'item.gift.add.n08.msg13': `礼品类别为必选`,
  'item.gift.add.n08.msg14': `礼品类目为必选`,
  'item.gift.add.n08.msg15': `获取积分为必填`,
  'item.gift.add.n08.msg16': `礼品价格精确到小数点后两位`,
  'item.gift.add.n08.msg17': `礼品价格长度不超过15位数`,
  'item.gift.add.n08.msg18': `总库存为必填`,
  'item.gift.add.n08.msg19': `总库存不超过十位数`,
  'item.gift.add.n08.msg20': `获取积分值不超过10位数`,
  'item.gift.add.n08.msg21': `图片过大`,
};

export const goods_enUS = {
  'item.gift.n01.lbl01': `GIFT ID`, //礼品编号
  'item.gift.n01.lbl02': `GIFT TITLE`, //礼品标题
  'item.gift.n01.rdo03': `GIFT STATUS`, //礼品状态
  'item.gift.n01.rdo04': `GIFT GROUP`, //礼品分组
  'item.gift.n01.rdo05': `GIFT ENTITY`, //礼品类别
  'item.gift.n01.rdo06': `GIFT TYPE`, //礼品类目
  'item.gift.n02.btn01': `ADD GIFT`, //添加礼品
  'item.gift.n02.btn02': `EXPORT`, //导出列表
  'item.gift.c01.lbl01': `GIFT ID`, //礼品编号
  'item.gift.c01.lbl02': `GIFT TITLE`, //礼品标题
  'item.gift.c01.lbl03': `GIFT STATUS`, //礼品分组
  'item.gift.c01.lbl04': `GIFT GROUP`, //礼品类别
  'item.gift.c01.lbl05': `GIFT TYPE`, //礼品类目
  'item.gift.c01.lbl06': `EXCHANGE POINTS`, //兑换积分
  'item.gift.c01.lbl07': `ISSUED`, //已领数量
  'item.gift.c01.lbl08': `REMAINING`, //剩余数量
  'item.gift.c01.lbl09': `ADD TIME`, //创建时间
  'item.gift.c01.lbl10': `GIFT STATUS`, //礼品状态
  'item.gift.c01.lbl11': `ACTION`, //操作
  'item.gift.d01.txt01': `Do you sure to take this item off the shelf?`,
  'item.gift.d01.txt02': `Do you sure to take this item on the shelf?？`,
  'item.gift.d02.txt01': `Do you sure to delete this item?？`,
  'item.gift.add.c02.lbl01': `VOUCHER`, //优惠券
  'item.gift.add.c02.lbl02': `VOUCHER DETAILS`, //优惠券内容
  'item.gift.add.c02.lbl03': `ACTION`, //操作
  'item.gift.add.n08.msg01': `COVER IMAGE IS REQUIRED`, //封面图片为必传
  'item.gift.add.n08.msg02': `COVER IMAGE MUST SMALLER THAN 10M`, //封面图片大小不超过10M
  'item.gift.add.n08.msg03': `GIFT TITLE MUST SHORTER THAN 30`, //礼品标题的最大长度不得大于30
  'item.gift.add.n08.msg04': `GIFT TITLE IS REQUIRED`, //礼品标题为必填项
  'item.gift.add.n08.msg05': `GIFT TITLE MUST BE FILLED IN`, //礼品标题不能为空
  'item.gift.add.n08.msg06': `GIFT SUB-TITLE IS REQUIRED`, //礼品副标题为必填项
  'item.gift.add.n08.msg07': `GIFT SUB-TITLE MUST BE FILLED IN`, //礼品副标题不能为空
  'item.gift.add.n08.msg08': `GIFT SUB-TITLE MUST SHORTER THAN 20`, //礼品副标题的最大长度不得大于20
  'item.gift.add.n08.msg09': `GIFT DETAIL IS REQUIRED`, //礼品详情为必填项
  'item.gift.add.n08.msg10': `GIFT DETAIL MUST BE FILLED IN`, //礼品详情不能为空
  'item.gift.add.n08.msg11': `GIFT DETAIL MUST SHORTER THAN 100`, //礼品详情的最大长度不得超过100
  'item.gift.add.n08.msg12': `GIFT `, //礼品分组为必选
  'item.gift.add.n08.msg13': `Error: VALUE`, //礼品类别为必选
  'item.gift.add.n08.msg14': `Error: VALUE`, //礼品类目为必选
  'item.gift.add.n08.msg15': `POINTS GAINED IS REQUIRED`, //获取积分为必填
  'item.gift.add.n08.msg16': `GIFT VALUE MUST BE ROUND UP TO 2 DECIMAL PLACES`, //礼品价格精确到小数点后两位
  'item.gift.add.n08.msg17': `GIFT VALUE MUST SHORTER THAN 15`, //礼品价格长度不超过15位数
  'item.gift.add.n08.msg18': `TOTAL INVENTORY MUST BE FILLED IN`, //总库存为必填
  'item.gift.add.n08.msg19': `TOTAL INVENTORY MUST SHORTER THAN 10`, //总库存不超过十位数
  'item.gift.add.n08.msg20': `POINTS GAINED MUST SHORTER THAN 10`, //获取积分值不超过10位数
  'item.gift.add.n08.msg21': `Photo Size too big`,
  'item.gift.add.n01.lbl01': `BASIC SETTINGS`, //基本设定
  'item.gift.add.n02.lbl01': `COVER PICTURE`, //封面图
  'item.gift.add.n02.lbl02': `PLEASE UPLOAD COVER PICTURE`, //请上传封面图
  'item.gift.add.n02.lbl03': `SUGGESTED SIZE:200PX*150PX`, //建议尺寸200px*150px
  'item.gift.add.n03.lbl01': `ITEM TITLE`, //礼品标题
  'item.gift.add.n03.lbl02': `ITEM SUB-TITLE`, //礼品副标题
  'item.gift.add.n03.lbl03': `ITEM DETAILS`, //礼品详情
  'item.gift.add.n04.rdo01': `ITEM GROUP`, //礼品分组
  'item.gift.add.n04.rdo02': `ITEM TYPE`, //礼品类别
  'item.gift.add.n04.rdo03': `ITEM CATEGORY`, //礼品类目
  'item.gift.add.n04.lbl04': `获取积分值`,
  'item.gift.add.n04.btn05': `Choose Voucher`,
  'item.gift.add.n04.lbl06': `ITEM PRICE`, //礼品价格
  'item.gift.add.n04.lbl07': `ITEM POINTS`, //礼品积分值
  'item.gift.add.n04.lbl08': `IN STOCK`, //总库存
  'item.gift.add.n05.lbl01': `DETAILS PICTURE`, //详情图
  'item.gift.add.n05.lbl02': `SUGGESTED SIZE:800PX*800PX,UPLOADED`, //建议尺寸800px*800px，已上传
  'item.gift.add.n06.lbl01': `SETTINGS`, //设置
  'item.gift.add.n06.lbl02': `Error: VALUE`, //库存预警设置
  'item.gift.add.n06.lbl03': `WHEN`, //库存小于
  'item.gift.add.n06.lbl04': `SENDING NOTIFICATIONS TO`, //时，弹框/消息通知品牌商补足库存礼品
  'item.gift.add.n07.lbl01': `ITEM STATUS`, //礼品状态
  'item.gift.add.n07.rdo02': `ON SHELF`, //上架
  'item.gift.add.n07.rdo03': `OFF SHELF`, //下架
  'item.gift.add.d01.placeholder01': `PLEASE ENTER VOUCHER NAME`, //请输入优惠券名称
  'item.gift.add.d01.lbl02': `CHOOSE VOUCHER`, //选择优惠券
  'item.gift.add.d01.lbl03': `VOUCHER NAME`, //优惠券名称
  'item.gift.add.d01.lbl04': `USED FOR`, //适用商品
  'item.gift.add.d01.lbl05': `DETAILS`, //优惠内容
  'item.gift.add.d01.lbl06': `PEOPLE LIMITED`, //领取人限制
  'item.gift.add.d01.lbl07': `LIMITED TIMES`, //限领次数
  'item.gift.add.d01.lbl08': `REMAINING`, //剩余库存
};
